<p-sidebar [(visible)]="visible" position="right" [baseZIndex]="10000" (onHide)="closeSidebar()">
  <label class="supportTitle">{{'app.support' | translate}}</label>
  <div class="dialogButton">
    <div class="dialogButton">
      <p-button type="button" label="{{'app.new-request' | translate}}" styleClass="p-button-outlined p-button-danger"
        icon="pi pi-plus" (click)="createRequest('assistence')"></p-button>
    </div>
    <div class="dialogButton">
      <p-button type="button" label="{{'app.feedback' | translate}}" styleClass="p-button-outlined p-button-danger"
        icon="pi pi-plus" (click)="createRequest('feedback')"></p-button>
    </div>
    <div class="dialogButton">
      <p-button type="button" label="{{'app.technical-problem' | translate}}"
        styleClass="p-button-outlined p-button-danger" icon="pi pi-plus"
        (click)="createRequest('technical')"></p-button>
    </div>
    <div class="dialogButton">
      <p-button type="button" label="{{'app.download-software' | translate}}" (click)=" downloadLivelet()"
        styleClass="p-button-outlined p-button-primary" icon="pi pi-download"></p-button>
    </div>
  </div>
</p-sidebar>